import { render, staticRenderFns } from "./PropertyManagementFee.vue?vue&type=template&id=9f195ad6&scoped=true&"
import script from "./PropertyManagementFee.vue?vue&type=script&lang=js&"
export * from "./PropertyManagementFee.vue?vue&type=script&lang=js&"
import style0 from "./PropertyManagementFee.vue?vue&type=style&index=0&id=9f195ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f195ad6",
  null
  
)

export default component.exports